var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, isValidElement } from 'react';
import { DefaultErrorFallback } from './subcomponents';
// todo: work with designers to show a default error message at some point in the future
var DefaultFallback = function (_a) {
    var error = _a.error, errorInfo = _a.errorInfo;
    return (_jsxs(DefaultErrorFallback, { children: [_jsx("h1", { children: "Something went wrong..." }), _jsx("h3", { children: "Message:" }), error.toString(), _jsx("h3", { children: "Stack trace:" }), errorInfo.componentStack] }));
};
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { error: undefined, hasError: false };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        // upd state and log out to the console afterwards
        this.setState({
            error: error,
            errorInfo: errorInfo,
            hasError: true
        }, function () {
            // eslint-disable-next-line no-console
            console.error("Error is:\n".concat(error, "\n---\nError info:\n").concat(errorInfo)); // nosonar
        });
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.state, hasError = _a.hasError, error = _a.error, errorInfo = _a.errorInfo;
        var _b = this.props, children = _b.children, fallback = _b.fallback;
        var hasCustomFallback = isValidElement(fallback);
        // show error if we have it
        if (hasError) {
            // show custom fallback if it's valid
            if (hasCustomFallback) {
                return React.cloneElement(fallback, {
                    error: error
                });
            }
            // otherwise, show a default fallback
            return _jsx(DefaultFallback, { error: error, errorInfo: errorInfo });
        }
        // otherwise, if no error, show children
        return children;
    };
    return ErrorBoundary;
}(Component));
export default ErrorBoundary;
//# sourceMappingURL=index.js.map